import { render } from "./App.vue?vue&type=template&id=369e11e1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanhuttmann/Downloads/lb-dm-nachhaltigkeitspreis-2024/lbdmnp24-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__